export default function Quality() {
  return (
    <section id="qualidade" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <div className="inline-block bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-semibold mb-6 uppercase tracking-wider">
              Excelência Técnica
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Qualidade e Compromisso em Cada Etapa
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              A Gleimatus investe constantemente em gestão técnica, capacitação profissional e inovação, garantindo o melhor desempenho em todas as etapas do processo construtivo.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Desde o planejamento até a entrega das chaves, cada obra é conduzida com responsabilidade, segurança e controle financeiro, assegurando rentabilidade ao investidor e satisfação ao morador.
            </p>

            {/* Process Steps */}
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl text-white font-bold text-lg flex-shrink-0">
                  1
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-1">Planejamento Estratégico</h4>
                  <p className="text-gray-600">Análise detalhada de viabilidade e projeto arquitetônico</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl text-white font-bold text-lg flex-shrink-0">
                  2
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-1">Execução Controlada</h4>
                  <p className="text-gray-600">Gestão rigorosa de prazos, custos e qualidade</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl text-white font-bold text-lg flex-shrink-0">
                  3
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-1">Acabamento Premium</h4>
                  <p className="text-gray-600">Atenção aos detalhes e materiais de primeira linha</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl text-white font-bold text-lg flex-shrink-0">
                  4
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg mb-1">Entrega e Pós-Venda</h4>
                  <p className="text-gray-600">Suporte completo e garantia de satisfação</p>
                </div>
              </div>
            </div>
          </div>

          {/* Images */}
          <div className="order-1 lg:order-2 relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://public.readdy.ai/ai/img_res/d45309edd33fa8f48ce8007866ff9ae9.jpg"
                  alt="Qualidade Gleimatus"
                  className="w-full h-80 object-cover object-top"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Luxury%20apartment%20interior%20under%20construction%2C%20premium%20materials%20installation%2C%20modern%20design%20details%2C%20professional%20construction%20quality%2C%20elegant%20finishes%2C%20sophisticated%20residential%20development&width=400&height=500&seq=quality-2-gleimatus&orientation=portrait"
                  alt="Compromisso Gleimatus"
                  className="w-full h-80 object-cover object-top"
                />
              </div>
            </div>
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl -z-10"></div>
          </div>
        </div>

        {/* Certifications */}
        <div className="mt-20 bg-gradient-to-br from-gray-50 to-amber-50/30 rounded-2xl p-12">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Nossos Diferenciais Técnicos
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-white rounded-2xl shadow-lg mx-auto mb-4">
                <i className="ri-file-list-3-line text-amber-600 text-3xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Gestão Técnica</h4>
              <p className="text-sm text-gray-600">Processos certificados</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-white rounded-2xl shadow-lg mx-auto mb-4">
                <i className="ri-user-star-line text-amber-600 text-3xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Equipe Qualificada</h4>
              <p className="text-sm text-gray-600">Profissionais experientes</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-white rounded-2xl shadow-lg mx-auto mb-4">
                <i className="ri-tools-line text-amber-600 text-3xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Tecnologia</h4>
              <p className="text-sm text-gray-600">Métodos modernos</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-white rounded-2xl shadow-lg mx-auto mb-4">
                <i className="ri-shield-check-line text-amber-600 text-3xl"></i>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Segurança</h4>
              <p className="text-sm text-gray-600">Normas rigorosas</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}